import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AggregationLevel } from "./services/dashboardTypes";
import dayjs from "dayjs";
import type { RootState } from "../../store/rootStore";

export interface ChartFilter {
  aggregationLevel: AggregationLevel;
  // Date objects or any mutable object is not serializable.
  // Either store it as string or use https://www.npmjs.com/package/@karmaniverous/serify-deserify
  fromDateIso: string | null;
  toDateIso: string | null;
}

export interface DashboardState {
  chartFilter: ChartFilter;
}

const initialState: DashboardState = {
  chartFilter: {
    aggregationLevel: "daily",
    fromDateIso: dayjs()?.tz().startOf("month").toISOString(),
    toDateIso: dayjs()?.tz().endOf("month").toISOString(),
  },
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setChartFilter(state, action: PayloadAction<ChartFilter>) {
      state.chartFilter = action.payload;
    },
    setChartFilterAggregationLevel(state, action: PayloadAction<AggregationLevel>) {
      state.chartFilter.aggregationLevel = action.payload;
    },
    setChartFilterDateRange(
      state,
      action: PayloadAction<{
        fromDateIso: string | null;
        toDateIso: string | null;
      }>,
    ) {
      const { fromDateIso, toDateIso } = action.payload;
      state.chartFilter.fromDateIso = fromDateIso;
      state.chartFilter.toDateIso = toDateIso;
    },
  },
});
export const { setChartFilterAggregationLevel, setChartFilterDateRange, setChartFilter } = dashboardSlice.actions;

export const selectDashboardChartFilter = (state: RootState) => state.dashboard.chartFilter;

export const dashboardReducer = dashboardSlice.reducer;
